import { Dispatch, SetStateAction } from "react";
import _ from "lodash";

import Button from "components/Button";
import PageHeader from "components/PageHeader";
import Skeleton from "components/Skeleton";
import Stack from "components/Stack";
import Tooltip from "components/Tooltip";

import AssetManagementActionsButton from "entities/AssetManagement/components/AssetManagementActionsButton";
import AssetManagementTableSettings from "entities/AssetManagement/components/AssetManagementTableSettings";
import AssetManagementToggle from "entities/AssetManagement/components/AssetManagementToggle";
import {
  AMColumn,
  AMResolution,
  AMVarianceDisplayMode,
} from "entities/AssetManagement/constants";

export interface IAssetManagementPageHeader {
  columns: Array<AMColumn>;
  resolution: AMResolution;
  editMode: boolean;
  showSubItems: boolean;
  showYearToDateColumn: boolean;
  hideEmptyRows: boolean;
  hasProforma: boolean;
  isLoading: boolean;
  onChangeEditMode: () => void;
  onChangeShowSubItems: Dispatch<SetStateAction<boolean>>;
  onChangeHideEmptyRows: Dispatch<SetStateAction<boolean>>;
  setShowYearToDateColumn: Dispatch<SetStateAction<boolean>>;
  setColumns: Dispatch<SetStateAction<Array<AMColumn>>>;
  setResolution: Dispatch<SetStateAction<AMResolution>>;
  varianceDisplayMode: Array<AMVarianceDisplayMode>;
  setVarianceDisplayMode: Dispatch<
    SetStateAction<Array<AMVarianceDisplayMode>>
  >;
  onExportButtonClick: () => void;
}

const AssetManagementPageHeader = ({
  columns,
  resolution,
  editMode,
  hasProforma,
  isLoading,
  showYearToDateColumn,
  onChangeEditMode,
  onChangeShowSubItems,
  setColumns,
  setResolution,
  varianceDisplayMode,
  setVarianceDisplayMode,
  showSubItems,
  hideEmptyRows,
  setShowYearToDateColumn,
  onChangeHideEmptyRows,
  onExportButtonClick,
}: IAssetManagementPageHeader) => (
  <PageHeader
    title="Asset management"
    actions={
      <Stack spacing={2} direction="row">
        {isLoading ? (
          _.range(4).map((index) => (
            <Skeleton key={index} variant="text" width={150} height={50} />
          ))
        ) : (
          <>
            {hasProforma && (
              <>
                <AssetManagementToggle
                  label="Edit mode"
                  onToggleChange={onChangeEditMode}
                  checked={editMode}
                  dataTestid="edit-mode"
                />
                <Tooltip
                  title={
                    editMode
                      ? "Exporting data is unavailable while in edit mode."
                      : undefined
                  }
                >
                  <span>
                    <Button
                      variant="outlined"
                      onClick={onExportButtonClick}
                      data-testid="export-button"
                      disabled={editMode}
                    >
                      Export
                    </Button>
                  </span>
                </Tooltip>
                <AssetManagementTableSettings
                  columns={columns}
                  setColumns={setColumns}
                  resolution={resolution}
                  setResolution={setResolution}
                  varianceDisplayMode={varianceDisplayMode}
                  setVarianceDisplayMode={setVarianceDisplayMode}
                  showYearToDateColumn={showYearToDateColumn}
                  setShowYearToDateColumn={setShowYearToDateColumn}
                  showSubItems={showSubItems}
                  hideEmptyRows={hideEmptyRows}
                  setShowSubItems={onChangeShowSubItems}
                  setHideEmptyRows={onChangeHideEmptyRows}
                />
              </>
            )}
            <AssetManagementActionsButton />
          </>
        )}
      </Stack>
    }
  />
);

export default AssetManagementPageHeader;
